import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import gsap from 'gsap';

export default function PageTransition() {
  const ref = useRef(null);
  const loc = useLocation();
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const tl = gsap.timeline();
    tl.set(el, { scaleX: 0, transformOrigin: 'left' });
    tl.to(el, { scaleX: 1, duration: 0.4, ease: 'power3.inOut' });
    tl.to(el, { scaleX: 0, transformOrigin: 'right', duration: 0.4, ease: 'power3.inOut', delay: 0.05 });
  }, [loc.pathname]);
  return (
    <div ref={ref} style={{
      position: 'fixed', inset: 0, background: '#FBF8F0',
      zIndex: 9000, pointerEvents: 'none', transform: 'scaleX(0)',
    }} />
  );
}
